var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 13.5H11",
    stroke: "#5F7483",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11.5H11",
    stroke: "#5F7483",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66683 11.4987H1.66683C1.31353 11.4976 0.975006 11.3568 0.725186 11.107C0.475366 10.8572 0.334551 10.5187 0.333496 10.1654V6.16536C0.334551 5.81207 0.475366 5.47354 0.725186 5.22372C0.975006 4.9739 1.31353 4.83309 1.66683 4.83203H14.3335C14.6868 4.83309 15.0253 4.9739 15.2751 5.22372C15.525 5.47354 15.6658 5.81207 15.6668 6.16536V10.1654C15.6658 10.5187 15.525 10.8572 15.2751 11.107C15.0253 11.3568 14.6868 11.4976 14.3335 11.4987H12.3335",
    stroke: "#5F7483",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6665 3.4987V0.832031H10.0572C10.234 0.832069 10.4035 0.902332 10.5285 1.02736L12.1378 2.6367C12.2629 2.76169 12.3331 2.93123 12.3332 3.10803V3.4987",
    stroke: "#5F7483",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 15.5C12.3332 15.6768 12.2629 15.8464 12.1379 15.9714C12.0129 16.0964 11.8433 16.1667 11.6665 16.1667H4.33317C4.15636 16.1667 3.98679 16.0964 3.86177 15.9714C3.73674 15.8464 3.6665 15.6768 3.6665 15.5V9.5H12.3332V15.5Z",
    stroke: "#5F7483",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33317 7.4974C2.70136 7.4974 2.99984 7.19892 2.99984 6.83073C2.99984 6.46254 2.70136 6.16406 2.33317 6.16406C1.96498 6.16406 1.6665 6.46254 1.6665 6.83073C1.6665 7.19892 1.96498 7.4974 2.33317 7.4974Z",
    stroke: "#5F7483",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6665 0.832031V3.4987H12.3332",
    stroke: "#5F7483",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.f4587bf2.svg";
export { ForwardRef as ReactComponent };